import React from 'react';
import ProfileLegalContent from '../components/profile/ProfileLegalContent';
import { termsFooter, termsSections } from '../constants/legalContent';

const ProfileTermsPage = () => (
  <ProfileLegalContent
    activeId="terms"
    title="Términos y Condiciones"
    sections={termsSections}
    footer={termsFooter}
  />
);

export default ProfileTermsPage;
